import { useState } from 'react';
import { Info } from 'lucide-react';

import { IconButtonTemplate } from '../../buttons/IconButtonTemplate';
import { Dialog } from '../../Dialog';
import { MapInfo } from '../MapInfo';

export const MapInfoButton = ({ className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className={className}>
        <IconButtonTemplate
          bgColor="border-whiteColor bg-whiteColor"
          handleClick={() => setIsOpen(true)}
          icon={Info}
          size={20}
        />
      </div>

      {isOpen && (
        <Dialog
          content={<MapInfo handleCancel={() => setIsOpen(false)} />}
          classes={'max-w-[540px] h-fit'}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};
